module.exports = __webpack_public_path__ + "static/media/Societe-Renovation-Vaud.7553909d.jpg";